import React, { useMemo } from 'react';
import moment from 'moment';
import { DislikeOutlined, FrownOutlined, LikeOutlined, MehOutlined, SmileOutlined } from '@ant-design/icons';
import classnames from 'classnames';

import EventIcon from './event-icon';
import style from './index.less';

const MessageEventEvalution = props => {
  const { data } = props;
  const { action, content, time, evaType, level, resolved } = data;

  const resolvedEle = useMemo(() => {
    if ([null, undefined, ''].includes(resolved)) {
      return '-';
    }

    if (resolved === 1) {
      return (
        <span className={`${style['evaluation-icon']} smile`}>
          <LikeOutlined />
          {'已解决'}
        </span>
      );
    }
    return (
      <span className={`${style['evaluation-icon']} frown`}>
        <DislikeOutlined />
        {'未解决'}
      </span>
    );
  }, [resolved]);

  const date = moment
    .utc(time)
    .local()
    .format('MM/DD HH:mm:ss');

  let text = '顾客评价';
  let levelText = (
    <span className={classnames(style['evaluation-icon'], 'smile')}>
      <SmileOutlined />
      {'好评'}
    </span>
  );
  if (evaType === 'update') {
    text = '顾客修改了评价';
  }
  if (level === 0) {
    levelText = (
      <span className={classnames(style['evaluation-icon'], 'frown')}>
        <FrownOutlined />
        {'差评'}
      </span>
    );
  } else if (level === 1) {
    levelText = (
      <span className={classnames(style['evaluation-icon'], 'meh')}>
        <MehOutlined />
        {'中评'}
      </span>
    );
  }
  return (
    <div className={style['event-box']}>
      <ul className={style.header}>
        <li>
          <EventIcon action={action} />
        </li>
        <li className={style.date}>{date}</li>
        <li>{text}</li>
        <li>{resolvedEle}</li>
        <li>{levelText}</li>
      </ul>
      {content ? (
        <>
          <div className={style['event-border']} />
          <div className={style['evaluation-content']}>{content}</div>
        </>
      ) : null}
    </div>
  );
};

export default MessageEventEvalution;
